import { useContext, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { Loader } from "../../../components";
import { Container, Card, Form } from "react-bootstrap";
import {
  Box,
  Alert,
  Button,
  Snackbar,
  Typography,
  CardHeader,
  CardActionArea,
  CardMedia,
  CardActions,
  IconButton,
} from "@mui/material";
import Carousel from "react-elastic-carousel";
import SaveIcon from "@mui/icons-material/Save";
import DeleteIcon from "@mui/icons-material/Delete";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { KeyOffRounded } from "@mui/icons-material";
import firebase from "firebase/compat/app";
import "firebase/compat/storage";
import useScreenWidth from "../../../hooks/useScreenWidth";

const UbahFotoPengajuanFidusia = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch, setting } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);

  let [gambar, setGambar] = useState(null);
  let [arrayImage, setArrayImage] = useState([]);
  let [arrayImageUrl, setArrayImageUrl] = useState([]);
  let arrayImageSubmitted = [];
  const [invalidImage, setinvalidImage] = useState(null);

  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 550, itemsToShow: 2 },
    { width: 768, itemsToShow: 3 },
    { width: 1200, itemsToShow: 4 },
  ];

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    getUrlImg();
    getPengajuanFidusiaById();
  }, [arrayImage]);

  const getUrlImg = () => {
    let tempArrayImageUrl = [];
    Object.keys(arrayImage).map(function (key, index) {
      tempArrayImageUrl.push(URL.createObjectURL(arrayImage[key]));
      setArrayImageUrl(tempArrayImageUrl);
    });
  };

  const getPengajuanFidusiaById = async () => {
    setLoading(true);
    const response = await axios.post(
      `${tempUrl}/pengajuanFidusiaGambarByPengajuanFidusiaId`,
      {
        id,
        _id: user.id,
        token: user.token,
      }
    );
    setGambar(response.data);
    setLoading(false);
  };

  const hapusGambar = async (img, i) => {
    if (window.confirm(`Yakin ingin menghapus gambar?`) == false) {
      return;
    }

    let tempGambar = gambar.filter((val) => {
      return val.linkGambar !== img.linkGambar;
    });

    setGambar(tempGambar);

    if (img.linkGambar && img.linkGambar !== "") {
      let image = firebase.storage().refFromURL(img.linkGambar);

      image
        .delete()
        .then(function () {
          console.log("image deleted");
        })
        .catch(function (error) {
          // An error occurred!
          console.log("an error occurred");
        });
    }

    // Delete Gambar
    try {
      await axios.post(`${tempUrl}/deleteSurveyFidusiaGambarByLinkGambar`, {
        linkGambar: img.linkGambar,
        kodeCabang: user.cabang.id,
        userIdInput: user.id,
        _id: user.id,
        token: user.token,
      });

      await axios.post(`${tempUrl}/deletePengajuanFidusiaGambar/${img.id}`, {
        kodeCabang: user.cabang.id,
        userIdInput: user.id,
        _id: user.id,
        token: user.token,
      });
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      console.log(error);
    }
  };

  const submit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      for (let tempGambarLama of gambar) {
        arrayImageSubmitted.push(tempGambarLama);
      }

      if (arrayImage.length === 0) {
        setLoading(false);
        navigate(`/daftarPengajuanFidusia/pengajuanFidusia/${id}`);
      }

      // console.log("arrayImage");
      // console.log(arrayImage);

      // Convert FileList to an array
      const imageArray = Array.from(arrayImage);

      const uploadPromises = imageArray.map(async (selectedFile, index) => {
        if (!selectedFile) return null;

        const storageRef = firebase.storage().ref();
        const fileRef = storageRef.child(
          `${Math.floor(Math.random() * 1000 + 1)}${selectedFile.name}`
        );

        await fileRef.put(selectedFile);
        const downloadURL = await fileRef.getDownloadURL();
        // console.log(`Upload ${index + 1}:`, downloadURL);

        return downloadURL;
      });

      // Wait for all uploads to finish
      const uploadedLinks = await Promise.all(uploadPromises);

      // Now the uploadedLinks array is in order
      // console.log("Final ordered links:", uploadedLinks);

      for (let link of uploadedLinks) {
        await axios.post(`${tempUrl}/savePengajuanFidusiaGambar`, {
          pengajuanFidusiaId: id,
          linkGambar: link,
          kodeCabang: user.cabang.id,
          userIdInput: user.id,
          _id: user.id,
          token: user.token,
        });
      }

      // Set the submitted images in order
      arrayImageSubmitted.push(...uploadedLinks);

      setLoading(false);
      navigate(`/daftarPengajuanFidusia/pengajuanFidusia/${id}`);
    } catch (error) {
      setLoading(false);
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      console.log(error);
    }
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <Container>
      <h3>Fidusia</h3>
      <h5 style={{ fontWeight: 400 }}>Ubah Foto Pengajuan</h5>
      <hr />
      <Form noValidate validated={validated} onSubmit={submit}>
        <Card style={{ padding: "10px" }}>
          <Card>
            <Card.Header>
              <Typography variant="h5" sx={titleStyle} color="primary">
                UPLOAD FOTO
              </Typography>
            </Card.Header>
            <Card.Body>
              <Box sx={showDataContainer}>
                <Box sx={showDataWrapper}>
                  {invalidImage !== null ? (
                    <h4 className="error"> {invalidImage} </h4>
                  ) : null}
                  <label className="text-white">Pilih Gambar :</label>
                  <input
                    accept="image/*"
                    type="file"
                    id="select-image"
                    style={{ display: "none" }}
                    onChange={(e) => setArrayImage(e.target.files)}
                    multiple
                  />
                  <label htmlFor="select-image">
                    <Button
                      variant="contained"
                      color="primary"
                      component="span"
                      endIcon={<FileUploadIcon />}
                    >
                      Unggah Gambar
                    </Button>
                  </label>
                </Box>
              </Box>
              <Box sx={listImageContainer}>
                {arrayImageUrl &&
                  arrayImage &&
                  arrayImageUrl.map((key, i) => (
                    <Card sx={imageCard} elevation={10}>
                      <CardActionArea>
                        <CardHeader
                          title={`Gambar`}
                          subheader={`No. ${i + 1}`}
                        />
                        <CardMedia
                          component="img"
                          height="200px"
                          src={key}
                          alt={KeyOffRounded.name}
                        />
                      </CardActionArea>
                    </Card>
                  ))}
              </Box>
            </Card.Body>
          </Card>

          <Card style={{ marginTop: "20px" }}>
            <Card.Header>
              <Typography variant="h5" sx={titleStyle} color="primary">
                FOTO LAMA
              </Typography>
            </Card.Header>
            <Card.Body>
              <Box sx={showDataContainer}>
                {gambar && (
                  <Carousel breakPoints={breakPoints} sx={carouselStyle}>
                    {gambar &&
                      gambar.map((img, i) => (
                        <Card sx={oldImageCard} elevation={10}>
                          <CardActionArea disableRipple>
                            <CardHeader
                              title={`Gambar`}
                              subheader={`No. ${i + 1}`}
                            />
                            <CardMedia
                              component="img"
                              height="100%"
                              src={img.linkGambar}
                              alt="gambar"
                              sx={oldImageCardMedia}
                              onClick={() => {
                                window.open(
                                  img.linkGambar,
                                  "_blank",
                                  "noopener,noreferrer"
                                );
                              }}
                            />
                          </CardActionArea>
                          <CardActions sx={oldImageCardAction}>
                            <IconButton aria-label="delete">
                              <DeleteIcon
                                color="error"
                                onClick={() => hapusGambar(img, i)}
                              />
                            </IconButton>
                          </CardActions>
                        </Card>
                      ))}
                  </Carousel>
                )}
              </Box>
            </Card.Body>
          </Card>

          <Box sx={spacingTop}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() =>
                navigate(`/daftarPengajuanFidusia/pengajuanFidusia/${id}`)
              }
              sx={{ marginRight: 2 }}
            >
              {"< Kembali"}
            </Button>
            <Button variant="contained" startIcon={<SaveIcon />} type="submit">
              Simpan
            </Button>
          </Box>
        </Card>
      </Form>
      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}
    </Container>
  );
};

export default UbahFotoPengajuanFidusia;

const spacingTop = {
  mt: 4,
};

const alertBox = {
  width: "100%",
};

const dialogContainer = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
};

const dialogWrapper = {
  width: "100%",
  marginTop: 2,
};

const textFieldContainer = {
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const textFieldWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};

const colorRed = {
  color: "red",
};

const titleStyle = {
  textAlign: "center",
  fontWeight: "600",
};

const showDataContainer = {
  mt: 4,
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const showDataWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const listImageContainer = {
  display: "flex",
  flexWrap: "wrap",
};

const imageCard = {
  m: "auto",
  mt: 2,
};

const carouselStyle = {
  display: "flex",
  height: "400px",
};

const oldImageCard = {
  m: "auto",
  mt: 2,
  maxWidth: "500px",
  maxHeight: "500px",
  display: "flex",
  flexDirection: "column",
};

const oldImageCardMedia = {
  display: "flex",
  maxHeight: "150px",
};

const oldImageCardAction = {
  display: "flex",
  justifyContent: "center",
  mt: "auto",
};
